angular.module("Main").controller("BookingKursSuccessController", ["$rootScope", "$scope", "$state", "$stateParams", "$location", "$translate", "$localStorage", "$window", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $stateParams, $location, $translate, $localStorage, $window, PaymentService, BookingService, SessionService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
            //unregisterEventHandler();
            $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        });

        getKursbuchungLayouKonfiguration();
        loadConfigs();
        loadLandingPageBSConfig();


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadLandingPageBSConfig() {
            BookingService.loadLandingPageBSConfig().then(function (data) {
                vm.landingPage = data;
                if (vm.landingPage.LandingPageBuchungssystem) {
                    if (window.location !== window.parent.location) {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageNewTabWithout = true;
                        } else {
                            vm.landingPageNewTabWith = true;
                        }

                        // The page is in an iframe
                    } else {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith("https", vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageWithout = true;
                        } else {
                            vm.landingPageWith = true;
                        }
                        // The page is not in an iframe
                    }
                }
            })
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.MRVerbergenKB = data.MRVerbergenKB;
                vm.NMRVerbergenKB = data.NMRVerbergenKB;
            });
        }

        vm.bookingLost = false;
        vm.cashBack = false;
        vm.cookies = SessionService.checkSession();
        vm.currentUser = $localStorage.user;

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isKurs = true;
        vm.isTermin = false;
        vm.isPayment = false;
        vm.isPayPal = false;

        if (!SessionService.getSessionId()) {
            $state.go("kursplan", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();


        function init() {
            vm.hasError = false;
            let userData = $localStorage.user;
            BookingService.checkStatus($stateParams.oid).then(function (status) {
                vm.status = status;
                if (vm.status.bezahlung === 3 && vm.status.preis > 0) {
                    vm.isPayment = true;
                }
                if (status.confirmed === true) {
                    vm.kursDataModel = ({
                        OrderNr: $stateParams.oid,
                        Bezeichnung: vm.status.artikel,
                        PreisZahl: vm.status.preis,
                        Start: vm.status.start,
                        Ende: vm.status.ende,
                        PersonNr: vm.status.personNr,
                        RessourcenIds: vm.status.ressourcesIds,
                        TerminNr: vm.status.terminNr,
                        RechnungsNr: vm.status.RechnungsNr,
                        BookingNr: vm.status.BookingNr
                    });
                    vm.zahlmethode = vm.status.Zahlmethode;
                    getDataForConfirm();
                } else {
                    if (!_.isNil($stateParams.isBlock)) {
                        BookingService.getBlockkursTermine($stateParams.bNr).then(function (data) {
                            vm.hasBlockkurse = true;
                            _.forEach(data, function (d) {
                                d.Tag = new Date(d.Start);
                                d.Tag = moment(d.Tag).format('YYYY-MM-DD').toString();
                                d.Start = moment(d.Start).format('HH:mm').toString();
                                d.Ende = moment(d.Ende).format('HH:mm').toString();
                            });
                            vm.blockkurse = data;
                        }).then(function () {
                            vm.kursDataModel = ({
                                OrderNr: $stateParams.oid,
                                Bezeichnung: vm.status.artikel,
                                PreisZahl: vm.status.preis,
                                Blockkurse: vm.blockkurse,
                                PersonNr: vm.status.personNr,
                                RessourcenIds: vm.status.ressourcesIds,
                                TerminNr: vm.status.terminNr,
                                Bezahlung: vm.status.bezahlung
                            });
                            bookIntoMV();
                            if (!status.confirmed && status.status !== "ERROR") {
                                getDataForConfirm();
                            }
                        });
                    } else {
                        vm.kursDataModel = ({
                            OrderNr: $stateParams.oid,
                            Bezeichnung: vm.status.artikel,
                            PreisZahl: vm.status.preis,
                            Start: vm.status.start,
                            Ende: vm.status.ende,
                            PersonNr: vm.status.personNr,
                            RessourcenIds: vm.status.ressourcesIds,
                            TerminNr: vm.status.terminNr
                        });
                        bookIntoMV();
                        if (!status.confirmed && status.status !== "ERROR") {
                            getDataForConfirm();
                        }
                    }
                }
            });

            vm.remindLocalePayment = $stateParams.locale;
        }

        vm.goto = function () {
            $state.go("kursplan", {sid: SessionService.getSessionId(), cid: $scope.cid, id: $scope.id});
        };

        function getDataForConfirm() {
            vm.personNr = vm.kursDataModel.PersonNr;
            let userData = $localStorage.user;
            BookingService.getUserDetails(userData.uid).then(function (data) {
                vm.memberNr = vm.personNr;
                vm.isMember = $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
                vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
                vm.member = $localStorage.user;
                vm.member.firstname = $localStorage.user.Firstname;
                vm.member.lastname = $localStorage.user.Lastname;
                vm.member.email = $localStorage.user.Email;
                if (!_.isNil(data)) {
                    vm.isLoggedIn = true;
                    vm.username = data.firstname + " " + data.lastname;
                    vm.hideLogin = true;
                    $rootScope.$emit("login");
                }
            }).then(function () {
                vm.onlyMitarbeiter = false;
                if(vm.cookies.kursData) {
                    let mitarbeiter = _.sortBy(_.filter(vm.cookies.kursData.kurs.AllRessources, {Mitarbeiter: 1}), 'Bezeichnung');
                    let nichtMitarbeiter = _.sortBy(_.filter(vm.cookies.kursData.kurs.AllRessources, {Mitarbeiter: 0}), 'Bezeichnung');
                    if (nichtMitarbeiter.length === 0 || _.isUndefined(nichtMitarbeiter) || nichtMitarbeiter === null || !nichtMitarbeiter) {
                        vm.onlyMitarbeiter = true;
                    }
                    let ress = _.concat(mitarbeiter, nichtMitarbeiter);
                    vm.ressources = _.join(_.map(ress, "Bezeichnung"), " ,");
                    vm.kursData = vm.kursDataModel;
                }
                 else {
                    var arr =  vm.kursDataModel.RessourcenIds.slice(2, -2);
                    var ids = _.split(arr, '"');
                    BookingService.getResourceNamesPayPal(ids).then(function (data) {
                        vm.ressources = _.join(_.map(_.sortBy(data, "Bezeichnung"),  "Bezeichnung"), " ,");
                    });
                    vm.kursData = vm.kursDataModel;
                }

            });
        }

        function bookIntoMV() {
            if (vm.captured) return;
            vm.captured = true;
            PaymentService.saveMVBooking($stateParams.oid, $translate.use()).then(function (data) {
                vm.zahlmethode = vm.status.Zahlmethode;
                if ((data && !_.isEmpty(data.rechnungsNr))) {
                    vm.kursDataModel.RechnungsNr = data.rechnungsNr;
                }
                if (data && data.data && !_.isEmpty(data.data.rechnungsNr)) {
                    vm.kursDataModel.RechnungsNr = data.data.rechnungsNr;
                }
                BookingService.saveAppointmentHistory(vm.kursDataModel.TerminNr, 8, 4, {s3Nr: $localStorage.user.uid});
                if(!_.isNil($stateParams.isBlock)) {
                    BookingService.sendMessageBlockkurs(vm.status.terminNr, $localStorage.user.uid)
                } else {
                    BookingService.sendMessage(vm.status.terminNr, $localStorage.user.uid);
                }
            }).catch(function (error) {
                BookingService.saveAppointmentBookingFailedHistory(error, vm.kursDataModel.TerminNr, $localStorage.user.uid, "BookingKursSuccessController");
                vm.hasError = true;
                $state.go("booking_kurs_error", {
                    cid: $stateParams.cid,
                    id: $stateParams.id,
                    oid: $stateParams.oid,
                    isKurs: true
                });
            })
        }

    }]);
